// eslint-disable-next-line import/no-cycle
import HttpClient from './http';

export const getActivityById = async (id) => {
  try {
    const resp = await HttpClient.get(`activities/${id}`);

    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const createActivity = async (data) => {
  try {
    const resp = await HttpClient.post('activities/new-activity', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const editActivity = async (data) => {
  try {
    const resp = await HttpClient.put('activities/update-activity', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};

export const editFullActivity = async (data) => {
  try {
    const resp = await HttpClient.put('activities/admin/update-activity', data);
    if (!resp || !resp.data) {
      return {
        success: false,
      };
    }
    return {
      success: true,
      data: resp.data,
    };
  } catch (error) {
    return {
      success: false,
    };
  }
};
